import { IPatchBodyCostQueryParams } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyCost/patchBodyCostQuery.type';
import { patchBodyCostFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyCost/patchBodyCostQueryFunction';
import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const patchBodyCostQueryOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  IPatchBodyCostQueryParams
> => ({
  mutationKey: ['patch-Body-const-option'],
  mutationFn: (params: IPatchBodyCostQueryParams) =>
    patchBodyCostFunction(params),
});
